/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getOrderHistoryPage = (): Layout => ({
	name: 'MyPages',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		aside: [{ name: 'AccountSidebar', id: 'side-bar' }],
		second: [{ name: 'OrderHistory', id: 'order-history' }],
		third: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
